import axios from 'axios';
import { SERVER_URL } from 'Constants';
import { buildUrl } from 'Util/FetchUtils';

const CARGO_API = `${SERVER_URL}/api/entity/CargoEntity`;

export interface CargoTypeDto {
	id: string;
	cargoMake: string;
	cargoModel: string;
}

export interface MeasurementDto {
	id: string;
	label: string;
	value: number;
}

export interface UserVehicleDto {
	id: string;
	cargoIdentification: string;
	cargoType: CargoTypeDto;
	selectedLengthId: string;
	selectedLength: MeasurementDto | null;
	selectedWeightId: string;
	selectedWeight: MeasurementDto | null;
	selectedWidthId: string | null;
	exactWeight: number | null;
	exactWeightUnit: string | null;
}

export interface UserVehiclesResponse {
	vehicles: UserVehicleDto[];
	count: number;
}

export interface UpdateVehicleData {
	cargoIdentification: string;
	cargoTypeId: string;
	selectedLengthId: string;
	selectedWeightId: string;
	selectedWidthId?: string | null;
}

export interface CreateVehicleData {
	cargoIdentification: string;
	cargoTypeId: string;
	selectedLengthId: string;
	selectedWeightId: string;
	selectedWidthId?: string | null;
	exactWeight?: number | null;
	exactWeightUnit?: string | null;
}

export function getUserVehicles(
	userId: string,
	skip: number,
	take: number,
	search?: string,
): Promise<UserVehiclesResponse> {
	const params: Record<string, string> = {
		skip: skip.toString(),
		take: take.toString(),
	};
	if (search && search.trim()) {
		params.search = search.trim();
	}
	return axios.get(buildUrl(`${CARGO_API}/user/${userId}`, params)).then(x => x.data);
}

export function updateUserVehicle(vehicleId: string, vehicleData: UpdateVehicleData): Promise<UserVehicleDto> {
	return axios.put(`${CARGO_API}/user-vehicle/${vehicleId}`, vehicleData).then(x => x.data);
}

export function createUserVehicle(userId: string, vehicleData: CreateVehicleData): Promise<UserVehicleDto> {
	return axios.post(`${CARGO_API}/user-vehicle/${userId}`, vehicleData).then(x => x.data);
}

export function getCargoTypes(): Promise<CargoTypeForVehicleDto[]> {
	return axios.get(`${CARGO_API}/cargo-types`).then(x => x.data);
}

export interface CargoTypeForVehicleDto {
	id: string;
	cargoMake: string;
	cargoModel: string;
	minimumLengthId: string;
	minimumWeightId: string;
	minimumWidthId?: string;
	exactWeight?: number | null;
	exactWeightUnit?: string | null;
	characteristicIds?: string[];
}

export function disableUserVehicle(vehicleId: string): Promise<void> {
	return axios.post(`${CARGO_API}/disable/${vehicleId}`);
}
